<template>
  <div>
    <!-- Search Properties Start -->
    <section class="search-properties section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="section-title2">
              Find Your Home
              <button
                @click="onSearchBoxToggle"
                type="button"
                class="app-property-search-toggle btn btn-common btn-sm"
              >
                <span
                  v-if="!getSearchToggleState"
                  class="fa fa-search-plus"
                ></span>
                <span
                  v-if="getSearchToggleState"
                  class="fa fa-search-minus"
                ></span>
                {{ searchToggleText }}
              </button>
            </h2>
          </div>
          <transition
            name="search-transition"
            enter-active-class="animate__animated animate__tada"
            leave-active-class="animate__animated animate__bounceOutRight"
          >
            <div v-if="getSearchToggleState">
              <!-- Start Search box -->
              <div class="search-bar">
                <div class="advanced-search">
                  <form class="search-form">
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.city"
                        :options="cityList"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onChangeCity"
                      ></v-select>
                    </div>
                    <div class="col-md-6 col-sm-6">
                      <v-select
                        v-model="sdata.locality"
                        :options="localityList"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.offerType"
                        :options="offerTypeOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.propertyType"
                        :options="propertyTypeOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.bedroom"
                        :options="bedroomOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.bathroom"
                        :options="bathroomOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <v-select
                        v-model="sdata.sortBy"
                        :options="sortByOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                        @input="onSearchInputChanged"
                      ></v-select>
                    </div>
                    <div class="col-md-6 col-sm-6 app-search-col-style">
                      <input
                        v-model="sdata.propertyCode"
                        v-mask="'####-####'"
                        type="text"
                        class="form-control app-property-search-text"
                        placeholder="Property reference #"
                        maxlength="9"
                      />
                    </div>
                    <div class="col-md-3 col-sm-3 app-search-col-style">
                      <div class="input-group">
                        <div class="input-group-btn">
                          <button
                            @click="getUserLocation"
                            title="current location"
                            type="button"
                            class="btn btn-info btn-sm"
                          >
                            <span class="fa fa-map-marker"></span>
                          </button>
                        </div>
                        <input
                          v-model="sdata.postcode"
                          @change="onChangePostcode"
                          :placeholder="sdata.currentLocation.placeHolder"
                          type="text"
                          class="form-control app-property-search-text"
                          maxlength="20"
                        />
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-3">
                      <v-select
                        v-model="sdata.searchRadius"
                        :options="searchRadiusOptions"
                        :reduce="(op) => op.value"
                        :clearable="false"
                        :searchable="false"
                      ></v-select>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-md-12 text-center">
                <button
                  @click="searchProperty"
                  class="btn btn-common"
                  style="margin-left:10px;"
                  type="button"
                >
                  Search
                </button>
                <div class="app-property-search-busy">
                  <span
                    v-if="showAnimation"
                    class="fa fa-spinner fa-spin fa-2x fa-fw"
                  ></span>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </section>
    <!-- Search Properties End -->
    <!-- Property Section Start -->
    <section class="property section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="section-title2">{{ title_text }}</h2>
          </div>
          <div class="col-md-12">
            <div class="app-property-search-paging">
              <button
                @click="onPreviousPageClicked"
                class="btn btn-common btn-sm"
                type="button"
                :disabled="aniPageNextBusy"
              >
                <i class="fa fa-chevron-left"></i> Previous
              </button>
              <span class="pages">{{ currentPage }} of {{ pageCount }}</span>
              <button
                @click="onNextPageClicked"
                class="btn btn-common btn-sm"
                type="button"
                :disabled="aniPageNextBusy"
              >
                Next <i class="fa fa-chevron-right"></i>
              </button>
            </div>
            <div class="busy-animation">
              <span
                v-if="aniPageNextBusy"
                class="fa fa-spinner fa-spin fa-2x fa-fw"
              ></span>
            </div>
          </div>
        </div>
        <transition-group
          tag="div"
          class="row app-grid-column-equal-height"
          name="animate-property"
          enter-active-class="animate__animated animate__fadeInLeft"
          leave-active-class="animate__animated animate__zoomOut"
        >
          <div
            @click="onPropertyItemClicked(item)"
            v-for="item in fdata"
            :key="item.pkey"
            class="col-md-4 col-sm-6 col-xs-12"
          >
            <div class="property-main">
              <div class="property-wrap">
                <div class="property-item">
                  <figure class="item-thumb">
                    <router-link
                      class="hover-effect"
                      :to="'/property-details/' + item.prp_PropertyCode"
                    >
                      <img
                        :src="item.prp_ImageList[0].data"
                        :alt="item.prp_PropertyCode"
                      />
                    </router-link>
                    <span class="label-featured">{{
                      item.prp_PropertyType
                    }}</span>
                    <div class="label-inner">
                      <span class="label-status label">{{
                        item.prp_OfferType
                      }}</span>
                    </div>
                    <div class="price">
                      <span class="item-price">{{ item.prp_PricePCM }}</span>
                      <span
                        v-if="item.prp_OfferType == 'For Rent'"
                        class="item-sub-price"
                        >{{ item.prp_PricePW }}</span
                      >
                    </div>
                    <ul class="actions">
                      <li>
                        <span class="add-fav"><i class="icon-heart"></i></span>
                      </li>
                    </ul>
                  </figure>
                  <div class="item-body">
                    <h5>PROPERTY REF: {{ item.prp_PropertyCode }}</h5>
                    <h3 class="property-title">
                      <router-link
                        class="hover-effect"
                        :to="'/property-details/' + item.prp_PropertyCode"
                      >
                        {{ item.prp_ShortDescription }}
                      </router-link>
                    </h3>
                    <div class="adderess">
                      <i class="icon-location-pin"></i> {{ item.prp_Address }}
                    </div>
                    <div class="info">
                      <p>
                        <span>Bedroom: {{ item.prp_Bedrooms }}</span
                        ><span>Bathroom: {{ item.prp_Bathrooms }}</span
                        ><span>{{ item.prp_FurnishType }}</span>
                      </p>
                      <p>
                        <i v-if="item.prp_ContactName" class="icon-user"></i>
                        {{ item.prp_ContactName }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item-foot date hide-on-list">
                <div class="pull-left">
                  <p class="prop-user-agent">
                    {{ item.prp_City }}-{{ item.prp_Suburb }}
                  </p>
                </div>
                <div class="pull-right">
                  <p class="prop-date">
                    <i class="icon-calendar"></i>{{ item.prp_DateAvailable }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </section>
    <!-- Property Section End -->
    <div>
      <modal
        name="alert-dialog-finder"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-default"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String },
    offer_type: { type: Number, default: 0 },
    title_text: {
      type: String,
      default: "Latest properties To Let / For Sale",
    },
  },
  data() {
    return {
      fdata: [],
      sdata: {
        city: 1,
        locality: null,
        bedroom: 0,
        bathroom: 0,
        propertyType: 0,
        offerType: 0 || this.offer_type,
        propertyCode: "",
        postcode: "",
        searchRadius: 0,
        sortBy: 0,
        page: 1,
        currentLocation: {
          placeHolder: "Postcode",
          latitude: null,
          longtitude: null,
        },
      },
      showAnimation: false,
      alertMessage: "",
      cityList: [],
      localityList: [],
      filterCity: "",
      filterSelect: "",
      aniLabelsLoading: false,
      aniPageNextBusy: false,
      currentPage: 1,
      pageCount: 1,
      searchToggleText: "Hide filters",
      offerTypeOptions: [
        { value: 0, label: "ALL OFFERS" },
        { value: 1, label: "Rent" },
        { value: 2, label: "Sale" },
      ],
      propertyTypeOptions: [
        { value: 0, label: "ALL TYPES" },
        { value: 1, label: "Detached" },
        { value: 2, label: "Semi-detached" },
        { value: 3, label: "Terraced" },
        { value: 4, label: "Flat" },
        { value: 5, label: "Bungalow" },
        { value: 6, label: "Land" },
        { value: 7, label: "Park Home" },
      ],
      bedroomOptions: [
        { value: 0, label: "ALL BEDROOMS" },
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" },
      ],
      bathroomOptions: [
        { value: 0, label: "ALL BATHROOMS" },
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" },
      ],
      searchRadiusOptions: [
        { value: 0, label: "SEARCH WITHIN" },
        { value: 0.25, label: "Within 1/4 mile" },
        { value: 0.5, label: "Within 1/2 mile" },
        { value: 1, label: "Within 1 mile" },
        { value: 3, label: "Within 3 miles" },
        { value: 5, label: "Within 5 miles" },
        { value: 10, label: "Within 10 miles" },
        { value: 15, label: "Within 15 miles" },
        { value: 20, label: "Within 20 miles" },
        { value: 30, label: "Within 30 miles" },
        { value: 40, label: "Within 40 miles" },
      ],
      sortByOptions: [
        { value: 0, label: "SORT" },
        { value: 1, label: "Lowest price first" },
        { value: 2, label: "Highest price first" },
        { value: 3, label: "Sort by date added" },
      ],
    };
  },
  /*
  watch: {
    offer_type: function(val) {
      if (val) {
        this.offerType = val;
      }
    },
  },
  */
  computed: {
    ...mapGetters(["getCurrentPage", "getSearchToggleState"]),
  },
  methods: {
    ...mapMutations(["setCurrentPage", "setSearchToggleState"]),
    searchProperty: async function() {
      if (!this.sdata.city) {
        this.alertMessage = "Please select City/Town";
        this.$modal.show("alert-dialog-finder");
        return;
      }
      this.showAnimation = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}SearchProperty`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.sdata));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      const { currentPage, pageCount, queryable } = rData;
      this.currentPage = pageCount == 0 ? 1 : currentPage;
      this.pageCount = pageCount || 1;

      if (queryable.length == 0) {
        this.showAnimation = false;
        this.fdata = [];
        this.alertMessage =
          "Sorry, no property found with selected criteria. You may try again using different criteria.";
        this.$modal.show("alert-dialog-finder");
        return;
      }
      this.fdata = Object.assign([], queryable);
      this.showAnimation = false;
    },
    onNextPageClicked: async function() {
      if (this.currentPage < this.pageCount) {
        this.aniPageNextBusy = true;
        this.currentPage += 1;
        this.sdata.page = this.currentPage;
        await this.searchProperty();
        this.aniPageNextBusy = false;
      }
    },
    onSearchInputChanged: async function() {
      this.sdata.page = 1;
      await this.searchProperty();
    },
    onPreviousPageClicked: async function() {
      if (this.currentPage > 1) {
        this.aniPageNextBusy = true;
        this.currentPage -= 1;
        this.sdata.page = this.currentPage;
        await this.searchProperty();
        this.aniPageNextBusy = false;
      }
    },
    onSearchBoxToggle: function() {
      this.setSearchToggleState(!this.getSearchToggleState);
      this.searchToggleText = this.getSearchToggleState
        ? "Hide filters"
        : "Show filters";
    },
    getLocalityList: async function() {
      this.aniLabelsLoading = true;
      const config = {
        params: { fkey: this.sdata.city },
      };
      let rData = [];
      try {
        const response = await axios.get(
          `${this.baseUrl}GetLocalityList`,
          config
        );
        rData = response.data;
      } catch (error) {
        this.aniLabelsLoading = false;
        console.error("Failed to load localities:", error);
        return;
      }
      rData.unshift({ value: 0, label: "All Areas" });
      this.localityList = rData;
      this.sdata.locality = 0;
      this.aniLabelsLoading = false;
    },
    getCityList: async function() {
      this.aniLabelsLoading = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}GetCityList`;
      try {
        ({ data: rData } = await axios.get(actionUrl));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        this.cityList = Object.assign([], rData);
      }
      this.aniLabelsLoading = false;
    },
    onChangeCity: async function() {
      if (!this.sdata.city) {
        this.localityList = [];
      } else {
        await this.getLocalityList();
        this.searchProperty();
      }
    },
    onChangePostcode: function() {
      Object.assign(this.sdata.currentLocation, {
        placeHolder: "Postcode",
        latitude: null,
        longtitude: null,
      });
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-finder");
    },
    onPropertyItemClicked: function(item) {
      this.$gtag.event("select_item", {
        item_list_id: item.prp_PropertyCode,
        item_list_name: item.prp_ShortDescription,
      });
      this.setCurrentPage(this.currentPage);
    },
    getUserLocation: async function() {
      try {
        this.sdata.currentLocation.placeHolder = "getting location...";
        const { lat, lng } = await this.$getLocation();
        this.sdata.currentLocation.latitude = lat;
        this.sdata.currentLocation.longtitude = lng;
        this.sdata.postcode = "current location";
      } catch {
        this.sdata.currentLocation.placeHolder = "postcode";
      }
      //console.log(loc);
    },
  },
  async mounted() {
    this.sdata.page = this.getCurrentPage;
    await this.getCityList();
    await this.getLocalityList();
    await this.searchProperty();
    this.$scrollTo(".app-grid-column-equal-height");
  },
};
</script>
